import { FieldType } from "../common/constants";
import { ARTICLE_DOC } from "./article";
import { COURSE_DOC } from "./course";

export const HOME_DOC = {
    fields: [
        {
            id: "heading",
            type: FieldType.TEXT,
            required: true,
            label: "HomePage.Heading",
            localizable: true,
        },
        {
            id: "content",
            type: FieldType.HTML,
            required: true,
            label: "HomePage.Content",
            localizable: true,
        },
        {
            id: "picture",
            type: FieldType.ASSET,
            filter: "image/*",
            required: true,
            label: "HomePage.MainPicture",
            localizable: false,
            picture: true,
        },
        {
            id: "featuredCourses",
            type: FieldType.REFERENCE,
            collection: "courses",
            label: "HomePage.TrendingCourses",
            localizable: false,
            form: COURSE_DOC,
            multiple: true,
        },
        {
            id: "featuredArticle",
            type: FieldType.REFERENCE,
            collection: "articles",
            label: "HomePage.FeaturedArticle",
            form: ARTICLE_DOC,
            localizable: false,
        },
    ],
};
